import { useI18n } from 'vue-i18n'
import columnStore from '@/stores/column'

export default function useAssetColumns(component: string) {
	const i18n = useI18n()
	const cols = columnStore()

	const numSubAssets = cols.define(component, '', i18n.t('asset.sub', 2), true)
	const inventoryNr = cols.define(component, 'inventory_nr', i18n.t('asset.inventoryNr'), false)
	const name = cols.define(component, 'name', i18n.t('misc.name'), true)
	const instance = cols.define(component, 'instance_id', i18n.t('institution'), true)
	const location = cols.define(component, 'location', i18n.t('location'), true)
	const price = cols.define(component, 'price', i18n.t('price'), false)
	const responsible = cols.define(component, 'responsible', i18n.t('responsible'), true)
	const status = cols.define(component, 'status', i18n.t('asset.status.label'), true)
	const comment = cols.define(component, 'comment', i18n.t('misc.comment'), true)
	const risks = cols.define(component, 'risks', i18n.t('risk.count'), true)
	const residual = cols.define(component, 'residual', i18n.t('risk.residual'), true)

	const columns = { numSubAssets, inventoryNr, name, instance, location, price, responsible, status, comment, risks, residual }

	const { custom, all } = cols.finalize(component, columns, true, ['assets'])

	return { columns, custom, all }
}
